import template from './dashboardWidget.template.html';

export default {
  template,
  bindings: {
    widgetType: '='
  },
controller: class controller {
    constructor(
      $rootScope,
      reportsService,
      dashboardService,
      ReportStatusType,
      DASHBOARD,
      TICKET,
      CONTACT
    ) {
      'ngInject';
      /*
       * Controller Model
       * --------------------------------------------------------------------------------
       */
      const ctrl = this;
      ctrl.data = [];
      ctrl.chart = {};
      ctrl.isReady = false;

      /*
       * Methods
       * --------------------------------------------------------------------------------
       */
      ctrl.initialize = () => {
        ctrl.currentOrganization = $rootScope.CurrentOrganization;
        ctrl.currentCurrency = $rootScope.CurrentCurrency();
        ctrl.currentTimeZone = $rootScope.CurrentTimeZone();
        ctrl.currentLocale = $rootScope.CurrentLocale();
        ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();

        const widget = dashboardService.getWidgets().find((wig) => wig.key === ctrl.widgetType);
        if (ctrl.widgetType.indexOf('CHART.') > -1) {
          reportsService.getWorkflowReport({ report: widget.report }).then((data) => {
            if (data && data.total && data.data && data.data.length) {
              ctrl.data = data.data;
              if (ctrl.widgetType.indexOf('CHART.STACKED.') > -1) {
                const chartData = {};
                chartData.xAxis = true;
                chartData.yAxis = true;
                chartData.dimension = 'value';
                chartData.currency = $rootScope.CurrentCurrency();
                chartData.data = [];
                // TIME BREAKDOWN CHART
                let valueKeys = _.reject(
                  _.keys(ctrl.data[0]),
                  (f) => f.indexOf('.sum.') === -1
                );
                if (valueKeys && valueKeys.length) {
                  _.forEach(valueKeys, (key) => {
                    if (data.data[0][key]) {
                      const chartItem = {};
                      let monthName;
                      const time = key.onlyNumbers();
                      if (key.indexOf('mn') > -1) {
                        monthName = moment
                          .utc()
                          .tz(
                            $rootScope.CurrentTimeZone() ? $rootScope.CurrentTimeZone() : 'UTC'
                          )
                          .subtract(time, 'months')
                          .format('MMM YYYY');
                      } else if (key.indexOf('mp') > -1) {
                        monthName = moment
                          .utc()
                          .tz(
                            $rootScope.CurrentTimeZone() ? $rootScope.CurrentTimeZone() : 'UTC'
                          )
                          .add(time, 'months')
                          .format('MMM YYYY');
                      } else {
                        monthName = moment
                          .utc()
                          .tz(
                            $rootScope.CurrentTimeZone() ? $rootScope.CurrentTimeZone() : 'UTC'
                          )
                          .add(time, 'months')
                          .format('MMM YYYY');
                      }
                      chartItem.label = monthName;
                      chartItem.value = parseInt(
                        String(data.data[0][`${key}`]).onlyNumbers(),
                        10
                      );
                      chartData.data.push(chartItem);
                    }
                  });
                } else {
                  // PIPELINE CHART
                  valueKeys = _.reject(_.keys(ctrl.data[0]), (f) => f.indexOf('.sum') === -1);
                  _.forEach(valueKeys, (key) => {
                    if (data.data[0][key]) {
                      const chartItem = {};
                      if (key.indexOf('created') > -1) {
                        chartItem.label = 'Created';
                      } else if (key.indexOf('submitted') > -1) {
                        chartItem.label = 'Submitted';
                      } else if (key.indexOf('approved') > -1) {
                        chartItem.label = 'Approved';
                      } else if (key.indexOf('settled') > -1) {
                        chartItem.label = 'Settled';
                      }
                      chartItem.value = parseInt(
                        String(data.data[0][`${key}`]).onlyNumbers(),
                        10
                      );
                      chartData.data.push(chartItem);
                    }
                  });
                }
                ctrl.chart = chartData;
              } else if (ctrl.widgetType.indexOf('CHART.GAUGE_MULTIPLE.') > -1) {
                const createdValue = parseInt(
                  String(ctrl.data[0]['aggregation.deal.created.sum']).onlyNumbers() || 0,
                  10
                );
                const submittedValue = parseInt(
                  String(ctrl.data[0]['aggregation.deal.submitted.sum']).onlyNumbers() || 0,
                  10
                );
                const approvedValue = parseInt(
                  String(ctrl.data[0]['aggregation.deal.approved.sum']).onlyNumbers() || 0,
                  10
                );
                const settledValue = parseInt(
                  String(ctrl.data[0]['aggregation.deal.settled.sum']).onlyNumbers() || 0,
                  10
                );
                ctrl.chart = {
                  format: true,
                  currency: $rootScope.CurrentCurrency(),
                  data: [
                    {
                      key: 'Settled',
                      value: settledValue,
                      percentage:
                        settledValue > 0 ? Math.round((settledValue / createdValue) * 100) : 0
                    },
                    {
                      key: 'Approved',
                      value: approvedValue,
                      percentage:
                        approvedValue > 0 ? Math.round((approvedValue / createdValue) * 100) : 0
                    },
                    {
                      key: 'Submitted',
                      value: submittedValue,
                      percentage:
                        submittedValue > 0
                          ? Math.round((submittedValue / createdValue) * 100)
                          : 0
                    },
                    {
                      key: 'Created',
                      value: createdValue,
                      percentage:
                        createdValue > 0 ? Math.round((createdValue / createdValue) * 100) : 0
                    }
                  ]
                };
              } else if (ctrl.widgetType.indexOf('CHART.GAUGE.') > -1) {
                const valueField = _.find(_.keys(ctrl.data[0]), (k) => k.indexOf('.sum') > -1);
                ctrl.chart = parseFloat(ctrl.data[0][valueField]);
              } else {
                let chartData = [];
                ctrl.data.forEach((item) => {
                  const chartItem = {};
                  chartItem.label = item[widget.report.fields[0]];
                  chartItem.value = item[widget.report.fields[1]];
                  chartItem.intValue = parseInt(
                    item[widget.report.fields[1]].toString().onlyNumbers(),
                    10
                  );
                  chartData.push(chartItem);
                });
                const max = _.maxBy(chartData, (item) => item.intValue);
                chartData.forEach((item) => {
                  item.dimension =
                    !isNaN(item.intValue / max.intValue) * 100
                      ? (item.intValue / max.intValue) * 100
                      : 0;
                });
                chartData = _.sortBy(chartData, 'dimension');
                ctrl.chart = chartData.reverse();
              }
            }
            ctrl.isReady = true;
          });
        } else if (ctrl.widgetType.indexOf('BARS.') > -1) {
          reportsService.getWorkflowReport({ report: widget.report }).then((data) => {
            ctrl.data = data.data;
            if (data && data.total && data.data && data.data.length) {
              let chartData = [];
              ctrl.data.forEach((item) => {
                const chartItem = {};
                chartItem.label = item[widget.report.fields[0]];
                chartItem.value = item[widget.report.fields[1]];
                chartItem.intValue = parseInt(
                  item[widget.report.fields[1]].toString().onlyNumbers(),
                  10
                );
                chartData.push(chartItem);
              });
              const max = _.maxBy(chartData, (item) => item.intValue);
              chartData.forEach((item) => {
                item.dimension =
                  !isNaN(item.intValue / max.intValue) * 100
                    ? (item.intValue / max.intValue) * 100
                    : 0;
              });
              chartData = _.sortBy(chartData, 'dimension');
              ctrl.chart = chartData.reverse();
            }
            ctrl.isReady = true;
          });
        } else if (ctrl.widgetType.indexOf('STATS.') > -1) {
          reportsService.getWorkflowReport({ report: widget.report }).then((data) => {
            if (data && data.total && data.data && data.data.length) {
              const source = data.data[0];
              const valueField = _.find(_.keys(source), (k) => k.indexOf('.sum') > -1);
              const countField = _.find(_.keys(source), (k) => k.indexOf('.count') > -1);
              ctrl.data = {
                count: data.data[0][countField],
                value: data.data[0][valueField],
                class: valueField.indexOf('settled') > -1 ? 'settled' : 'created'
              };
            } else {
              ctrl.data = {
                count: 0,
                value: 0,
                class: 'created'
              };
            }
          });
        } else if (ctrl.widgetType.indexOf('REPORT.TICKET.') > -1) {
          reportsService.getWorkflowReport({ report: widget.report }).then((data) => {
            ctrl.data = data.data;
            ctrl.isReady = true;
          });
        } else if (ctrl.widgetType.indexOf('REPORT.PRODUCT.') > -1) {
          reportsService.getWorkflowReport({ report: widget.report }).then((data) => {
            ctrl.data = data.data;
            ctrl.isReady = true;
          });
        } else if (ctrl.widgetType.indexOf('REPORT.ANNIVERSARY.') > -1) {
          reportsService.getWorkflowReport({ report: widget.report }).then((data) => {
            ctrl.data = _.sortBy(data.data, 'relAnniversaries.daysDifference');
            ctrl.isReady = true;
          });
        } else if (ctrl.widgetType.indexOf('LIST.DEALS.') > -1) {
          dashboardService
            .getTopTickets({ pluck: TICKET.FIELDS.BOARD, criteria: widget.criteria })
            .then((data) => {
              ctrl.data = data;
              ctrl.isReady = true;
            });
        } else if (ctrl.widgetType.indexOf('LIST.NOTES.') > -1) {
          dashboardService
            .getTopNotes({ pluck: [], criteria: widget.criteria })
            .then((data) => {
              ctrl.data = data;
              ctrl.isReady = true;
            });
        } else if (ctrl.widgetType.indexOf('LIST.JOBS.') > -1) {
          dashboardService.getTopJobs({ pluck: [], criteria: widget.criteria }).then((data) => {
            ctrl.data = data;
            ctrl.isReady = true;
          });
        } else if (ctrl.widgetType.indexOf('LIST.CONTACTS.') > -1) {
          dashboardService
            .getTopContacts({ pluck: CONTACT.FIELDS.WTF_LIST, criteria: widget.criteria })
            .then((data) => {
              ctrl.data = data;
              ctrl.isReady = true;
            });
        }
      };

      /*
       * Execute when all bindings are completed
       * --------------------------------------------------------------------------------
       */
      this.$onInit = () => {
        ctrl.initialize();
      };

      /*
       * Execute when bindings change
       * --------------------------------------------------------------------------------
       */
      this.$onChanges = (changes) => {};
    }
  }
};
